// extracted by mini-css-extract-plugin
export var categories = "styles-module--categories--94d90";
export var categoriesContainer = "styles-module--categories-container--07e0c";
export var categories_item = "styles-module--categories_item--60fa4";
export var firstPage = "styles-module--first-page--cd978";
export var secondPage = "styles-module--second-page--d3ea1";